angular.module('app').config(addonsRouting);

function addonsRouting($routeProvider) {
  $routeProvider.when('/addons', {
    pageTitle: 'ADDONS',
    template: '<addons-page></addons-page>',
    menu: 'features',
    accessPermission: 'index_addon_superadmin',
    authReq: true,
  });
}

addonsRouting.$inject = ['$routeProvider'];
